import {
  PACIENTE_SUCCESS,
  PACIENTE_LOADING,
  PACIENTE_ERROR,
  PACIENTE_EDITAR,
  PACIENTE_LOGOUT,
  RESET_PACIENTE,
  EDITANDO_PACIENTE,
  GETDATOSPACIENTE_SUCCESS,
  FINALIZAEDICION_PACIENTE,
  PACIENTE_BIOSEGURIDAD,
  PACIENTE_BIOSEGURIDAD_ERROR,
  PACIENTE_CAMBIOCLAVE,
  PACIENTE_EDITACLAVE,
  DROPDOWN_SELECT_USER_EDITAR_P,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";
import { parseBackendError } from "../../../../global/utils/errorHandler";

// Debe traer el idPacFamiliar
export const wsPostEditarPaciente = (paciente, idPacFamiliar) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  const payload = {
    ...paciente,
    fecha_nacimiento: paciente.fecha_nacimiento !== "" ? paciente.fecha_nacimiento : null,
    idlocalidad: paciente.idlocalidad !== "" ? paciente.idlocalidad : null,
  };

  axiosLogin().then((respuesta) => {
    respuesta
      .put(
        `/v1/paciente/editarPaciente/${!idPacFamiliar ? "" : idPacFamiliar}`,
        payload
      )
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "editePaciente",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          status: err.response?.status || 500,
          detalle: parsedError.userMessage, // Legacy field
          origen: "editePaciente",
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};
// export const wsPostEditarPaciente = (paciente, idPacFamiliar) => (dispatch) => {
//   dispatch({
//     type: PACIENTE_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .post(
//         `/paciente/editarPaciente/${!idPacFamiliar ? "" : idPacFamiliar}`,
//         paciente
//       )
//       .then((res) => {
//         let respuesta = {
//           ...res.data,
//           origen: "editePaciente",
//         };
//         dispatch({
//           type: PACIENTE_SUCCESS,
//           payload: respuesta,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           status: err.response.status,
//           detalle: err.response.data,
//           origen: "editePaciente",
//         };

//         dispatch({
//           type: PACIENTE_ERROR,
//           payload: error,
//         });
//       });
//   });
// };

//AGREGADOS.
export const editaPerfil = (handleHabilitaFormulario) => (dispatch) => {
  dispatch({
    type: EDITANDO_PACIENTE,
    payload: handleHabilitaFormulario,
  });
};

export const finalizaEdicion = () => (dispatch) => {
  dispatch({
    type: FINALIZAEDICION_PACIENTE,
  });
};
export const editarPaciente = (usuario) => (dispatch) => {
  dispatch({
    type: PACIENTE_EDITAR,
    payload: usuario,
  });
};

// Debe traer el idPacFamiliar
export const wsGetDatosPaciente =
  (idPacFamiliar, busqTurnos, nextStep) => (dispatch) => {
    dispatch({
      type: PACIENTE_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `/v1/paciente/GetDatosPaciente/${!busqTurnos ? false : busqTurnos}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((res) => {
          let respuesta = {
            ...res.data,
            origen: "actualizoDatos",
          };
          dispatch({
            type: GETDATOSPACIENTE_SUCCESS,
            error: null,
            loading: false,
            payload: respuesta,
          });
          if (nextStep) nextStep(true, res.data);
        })
        .catch((err) => {
          // Normalizamos el error usando el error handler centralizado
          const parsedError = parseBackendError(err);

          // Estructura normalizada con compatibilidad para código legacy
          let error = {
            detail: parsedError.userMessage, // Legacy field
            origen: "actualizoDatos",
            status: err.response?.status || 500,
            userMessage: parsedError.userMessage,
            technicalDetails: parsedError.technicalDetails,
            type: parsedError.type,
            validationErrors: parsedError.validationErrors,
            rawData: parsedError.rawData,
          };

          dispatch({
            type: PACIENTE_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error.detail);
        });
    });
  };
// export const wsGetDatosPaciente =
//   (idPacFamiliar, busqTurnos, nextStep) => (dispatch) => {
//     dispatch({
//       type: PACIENTE_LOADING,
//     });

//     axiosInstance().then((respuesta) => {
//       respuesta
//         .get(
//           `/paciente/GetDatosPaciente/${!busqTurnos ? false : busqTurnos}/${
//             !idPacFamiliar ? "" : idPacFamiliar
//           }`
//         )
//         .then((res) => {
//           let respuesta = {
//             ...res.data,
//             origen: "actualizoDatos",
//           };
//           dispatch({
//             type: GETDATOSPACIENTE_SUCCESS,
//             error: null,
//             loading: false,
//             payload: respuesta,
//           });
//           if (nextStep) nextStep(true, res.data);
//         })
//         .catch((err) => {
//           let error = {
//             detail: err.response
//               ? err.response.data
//               : "Error al contactar el server.",
//             origen: "actualizoDatos",
//           };

//           dispatch({
//             type: PACIENTE_ERROR,
//             payload: error,
//           });
//           if (nextStep) nextStep(false, error.detail);
//         });
//     });
//   };

export const editandoClave = (body) => (dispatch) => {
  dispatch({
    type: PACIENTE_EDITACLAVE,
    payload: body,
  });
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Debe traer el id del paciente
export const wsPostActualizarClave =
  (clave, nueva_clave, paciente, token, retryCount = 0) => (dispatch) => {
    dispatch({
      type: PACIENTE_LOADING,
    });
    const body = {
      clave,
      actual: clave,
      nueva_clave,
      paciente,
      token,
    };
    axiosLogin()
      .then((respuesta) => {
        respuesta
          .post(`/shared/Pacientes/cambiar_clave`, body)
          .then((res) => {
            let respuestaData = {
              ...res.data,
              origen: "cambioClave",
            };
            dispatch({
              type: PACIENTE_CAMBIOCLAVE,
              payload: respuestaData,
            });
          })
          .catch(async (err) => {
            const status = err.response?.status;
            const isThrottled = status === 429 && retryCount === 0;
            if (isThrottled) {
              await delay(5000);
              dispatch(wsPostActualizarClave(clave, nueva_clave, paciente, token, 1));
              return;
            }
            const parsedError = parseBackendError(err);
            let error = {
              status: status || 500,
              origen: "cambioClave",
              texto: parsedError.userMessage,
              userMessage: parsedError.userMessage,
              technicalDetails: parsedError.technicalDetails,
              type: parsedError.type,
              validationErrors: parsedError.validationErrors,
              rawData: parsedError.rawData,
            };
            dispatch({
              type: PACIENTE_ERROR,
              payload: error,
            });
          });
      })
      .catch((err) => {
        const parsedError = parseBackendError(err);
        dispatch({
          type: PACIENTE_ERROR,
          payload: {
            status: err?.response?.status || 500,
            origen: "cambioClave",
            texto: parsedError.userMessage,
            userMessage: parsedError.userMessage,
          },
        });
      });
  };
// export const wsPostActualizarClave =
//   (clave, nueva_clave, paciente, token) => (dispatch) => {
//     dispatch({
//       type: PACIENTE_LOADING,
//     });
//     axiosInstance().then((respuesta) => {
//       respuesta
//         .post(`/paciente/cambiar_clave`, {
//           clave: clave,
//           nueva_clave: nueva_clave,
//           paciente: paciente,
//           token: token,
//         })
//         .then((res) => {
//           let respuesta = {
//             ...res.data,
//             origen: "cambioClave",
//           };
//           dispatch({
//             type: PACIENTE_CAMBIOCLAVE,
//             payload: respuesta,
//           });
//         })
//         .catch((err) => {
//           let error = {
//             status: err.response.status,
//             origen: "cambioClave",
//             texto: err.response.data !== undefined ? err.response.data : "",
//           };
//           dispatch({
//             type: PACIENTE_ERROR,
//             payload: error,
//           });
//         });
//     });
//   };

export const wsPutAceptaWsp = (valor, idPacFamiliar) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .put(
        `/v1/paciente/aceptaAlertaWapp/${valor}/${
          !idPacFamiliar ? "" : idPacFamiliar
        }`
      )
      .then((res) => {
        let data = {
          pacienteActualizado: res.data,
          origen: "aceptaWsp",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          detail: parsedError.userMessage, // Legacy field
          origen: "aceptaWsp",
          status: err.response?.status || 500,
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};
// export const wsPutAceptaWsp = (valor, idPacFamiliar) => (dispatch) => {
//   dispatch({
//     type: PACIENTE_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .put(
//         `/paciente/aceptaAlertaWapp/${valor}/${
//           !idPacFamiliar ? "" : idPacFamiliar
//         }`
//       )
//       .then((res) => {
//         let data = {
//           pacienteActualizado: res.data,
//           origen: "aceptaWsp",
//         };
//         dispatch({
//           type: PACIENTE_SUCCESS,
//           payload: data,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//           origen: "aceptaWsp",
//         };

//         dispatch({
//           type: PACIENTE_ERROR,
//           payload: error,
//         });
//       });
//   });
// };

// Dejo 2 funciones /registro que se utilizan por fuera de signIn pero que tienen que ver con el Paciente.

export const wsGetCambioClave = (dni, nextStep) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .post("/shared/registro/cambio-clave/", { dni })
      .then((res) => {
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: res.data,
        });
        nextStep(true, res.data);
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        const error = {
          status: err.response?.status || 500,
          data: parsedError.userMessage, // Mensaje normalizado para el usuario
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
        nextStep(false, error);
      });
  });
};
// export const wsGetCambioClave = (dni, nextStep) => (dispatch) => {
//   dispatch({
//     type: PACIENTE_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get("/registro/cambio_clave/" + dni)
//       .then((res) => {
//         dispatch({
//           type: PACIENTE_SUCCESS,
//           payload: res.data,
//         });
//         nextStep(true, res.data);
//       })
//       .catch((err) => {
//         let error = {
//           status: err.response.status,
//           data: err.response.data,
//         };
//         dispatch({
//           type: PACIENTE_ERROR,
//           payload: error,
//         });
//         nextStep(false, error);
//       });
//   });
// };

export const wsPostConfirmaCodigo = (codigo, nextStep) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .post("/shared/registro/cambio-clave/codigo", {
        codigo: codigo,
      })
      .then((res) => {
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: res.data,
        });
        if (res.data !== null) {
          nextStep(true, res.data);
        }
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          status: err.response?.status || 500,
          data: parsedError.userMessage, // Legacy field
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };
        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
        nextStep(false, error);
      });
  });
};
// export const wsPostConfirmaCodigo = (codigo, nextStep) => (dispatch) => {
//   dispatch({
//     type: PACIENTE_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .post("/registro/cambio_clave/codigo", {
//         codigo: codigo,
//       })
//       .then((res) => {
//         dispatch({
//           type: PACIENTE_SUCCESS,
//           payload: res.data,
//         });
//         if (res.data !== null) {
//           nextStep(true, res.data);
//         }
//       })
//       .catch((err) => {
//         let error = {
//           status: err.response.status,
//           data: err.response.data,
//         };
//         dispatch({
//           type: PACIENTE_ERROR,
//           payload: error,
//         });
//         nextStep(false, error);
//       });
//   });
// };

/* export const vinculaSocial = (id, red, token, tokenRedSocial) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/paciente/vincular_red/", {
        id,
        red,
        token,
        tokenRedSocial,
      })
      .then((res) => {
        sessionStorage.token = token;
        let respuesta = {
          ...res.data,
          origen: "vinculaSocial",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "vinculaSocial",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
}; */
export const vinculaSocial = (id, red, token, tokenRedSocial) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .post("shared/Pacientes/vincular_red", {
        id,
        red,
        token,
        tokenRedSocial,
      })
      .then((res) => {
        sessionStorage.token = token;
        let respuesta = {
          ...res.data,
          origen: "vinculaSocial",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          detail: parsedError.userMessage, // Legacy field
          origen: "vinculaSocial",
          status: err.response?.status || 500,
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

/* export const desvinculaSocial = (red, token) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/paciente/desvincular_red/", {
        red,
      })
      .then((res) => {
        sessionStorage.token = token;
        let respuesta = {
          ...res.data,
          origen: "desvinculaSocial",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "desvinculaSocial",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
}; */

export const desvinculaSocial = (red) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .post("shared/Pacientes/desvincular_red", {
        red,
      })
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "desvinculaSocial",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          detail: parsedError.userMessage, // Legacy field
          origen: "desvinculaSocial",
          status: err.response?.status || 500,
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

/* export const wsPostEditaImagenPerfil = (body) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/paciente/perfil", body)
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "editaFoto",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "editaFoto",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
}; */

export const wsPostEditaImagenPerfil = (body) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .post("shared/Pacientes/foto", body)
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "editaFoto",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          detail: parsedError.userMessage, // Legacy field
          origen: "editaFoto",
          status: err.response?.status || 500,
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetDatosBioseguridad = (idPaciente, nextStep) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(
        `/shared/Pacientes/GetBioseguridadPaciente/${
          idPaciente ? idPaciente : ""
        }`
      )
      .then((res) => {
        dispatch({
          type: PACIENTE_BIOSEGURIDAD,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        const errorPayload = {
          status: err.response?.status || 500,
          data: parsedError.userMessage, // Legacy compatibility
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        dispatch({
          type: PACIENTE_BIOSEGURIDAD_ERROR,
          payload: errorPayload,
        });
        if (nextStep) nextStep(false, errorPayload);
      });
  });
};

export const wsGetImagenPerfil = (format, nextStep) => (dispatch) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/shared/Pacientes/foto${!format ? "" : "?format=" + format}`)
      .then((res) => {
        const base64 = res.data.base64;
        if (!base64) {
          if (nextStep) nextStep(true, base64);
          return;
        }
        // Comprimir la imagen recibida a JPEG 0.8 para evitar que ocupe demasiado
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          const compressed = canvas.toDataURL("image/jpeg", 0.8).split(",")[1];
          if (nextStep) nextStep(true, compressed);
        };
        img.onerror = () => {
          if (nextStep) nextStep(true, base64);
        };
        img.src = "data:image/jpeg;base64," + base64;
      })
      // .get(`/shared/Pacientes/foto${!format ? "" : "?format=" + format}`, {
      //   responseType: "blob", // 👈 MUY IMPORTANTE
      // })
      // .then((res) => {
      //   const url = URL.createObjectURL(res.data); // lo convertís en URL temporal
      //   if (nextStep) nextStep(true, url); // devolvés la URL lista para <img>
      // })
      .catch((err) => {
        // Normalizamos el error usando el error handler centralizado
        const parsedError = parseBackendError(err);

        // Estructura normalizada con compatibilidad para código legacy
        let error = {
          detail: parsedError.userMessage, // Legacy field
          origen: "fotoPerfil",
          status: err.response?.status || 500,
          userMessage: parsedError.userMessage,
          technicalDetails: parsedError.technicalDetails,
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          rawData: parsedError.rawData,
        };

        if (nextStep) nextStep(false, error.detail);
      });
  });
};

export const logoutPaciente = (history) => (dispatch) => {
  sessionStorage.removeItem("token");
  dispatch({ type: PACIENTE_LOGOUT });
  history.push("/");
};

export const logoutPacientePerfil = () => (dispatch) => {
  dispatch({ type: PACIENTE_LOGOUT });
};

//FINALIZA AGREGADOS.

export const resetPaciente = () => (dispatch) => {
  dispatch({
    type: RESET_PACIENTE,
  });
};

export const logoutPacienteDefault = () => (dispatch) => {
  dispatch({ type: PACIENTE_LOGOUT });
};

// funcion de los dropdowns

export const setUserSelectEditar = (payload) => (dispatch) => {
  dispatch({
    type: DROPDOWN_SELECT_USER_EDITAR_P,
    payload,
  });
};
